import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";
import { PickUpOpeningPage } from "~/components/PickUpOpeningPage";

export const Route = createFileRoute("/$hubMetaName/pick-up/opening")({
	beforeLoad: () => {
		document.title = "bacehub | Startseite";
	},
	component: RouteComponent,
	validateSearch: zodValidator(
		z.object({
			finishPath: z.string().optional(),
			problemPath: z.string().optional(),
			unlockRequestId: z.string(),
		})
	),
});

export default function RouteComponent() {
	const navigate = useNavigate();
	const { unlockRequestId, finishPath, problemPath } = Route.useSearch();
	return (
		<PickUpOpeningPage
			unlockRequestId={unlockRequestId}
			onOpened={() => {
				navigate({
					from: Route.fullPath,
					to: "/$hubMetaName/pick-up/collect",
					search: { unlockRequestId, finishPath, problemPath },
				});
			}}
			onClosed={() => {
				if (finishPath) navigate({ to: finishPath });
				else navigate({ from: Route.fullPath, to: "/$hubMetaName/pick-up/finish" });
			}}
			onExit={() => navigate({ to: "/" })}
		/>
	);
}
